var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        "max-width": "800px",
        fullscreen: _vm.$vuetify.breakpoint.xsOnly
      },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c("validation-observer", {
        ref: "validator",
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var valid = ref.valid
              return [
                _c(
                  "v-card",
                  {
                    staticClass: "d-flex flex-column",
                    attrs: { "min-height": "100%" }
                  },
                  [
                    _c("v-card-title", { staticStyle: { height: "64px" } }, [
                      _vm.editMode
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("_users._user_dialog.edit_user")
                                ) +
                                " "
                            )
                          ])
                        : _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("_users._user_dialog.add_user")) +
                                " "
                            )
                          ])
                    ]),
                    _c(
                      "v-card-text",
                      { staticClass: "flex-grow-1" },
                      [
                        _c(
                          "v-form",
                          [
                            _c(
                              "v-container",
                              [
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "12", sm: "6" } },
                                      [
                                        _c("salutation-select", {
                                          attrs: {
                                            label: _vm.$t("salutation"),
                                            outlined: "",
                                            dense: "",
                                            "hide-details": ""
                                          },
                                          model: {
                                            value: _vm.model.salutation,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.model,
                                                "salutation",
                                                $$v
                                              )
                                            },
                                            expression: "model.salutation"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "12", sm: "6" } },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            rules: "required",
                                            name: _vm.$t("short_code")
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "short_code"
                                                        ),
                                                        outlined: "",
                                                        dense: "",
                                                        "error-messages": errors,
                                                        "hide-details":
                                                          errors.length === 0
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.model.shortCode,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.model,
                                                            "shortCode",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "model.shortCode"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "12", sm: "6" } },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            rules: "required",
                                            name: _vm.$t("firstName")
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "firstName"
                                                        ),
                                                        outlined: "",
                                                        dense: "",
                                                        "error-messages": errors,
                                                        "hide-details":
                                                          errors.length === 0
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.model.firstName,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.model,
                                                            "firstName",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "model.firstName"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "12", sm: "6" } },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            rules: "required",
                                            name: _vm.$t("lastName")
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "lastName"
                                                        ),
                                                        outlined: "",
                                                        dense: "",
                                                        "error-messages": errors,
                                                        "hide-details":
                                                          errors.length === 0
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.model.lastName,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.model,
                                                            "lastName",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "model.lastName"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            rules: "required|email",
                                            name: _vm.$t("email")
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: _vm.$t("email"),
                                                        outlined: "",
                                                        dense: "",
                                                        "error-messages": errors,
                                                        "hide-details":
                                                          errors.length === 0
                                                      },
                                                      model: {
                                                        value: _vm.model.email,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.model,
                                                            "email",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "model.email"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      [
                                        _c("address-input", {
                                          ref: "addressInput",
                                          attrs: {
                                            outlined: "",
                                            dense: "",
                                            "hide-details": ""
                                          },
                                          model: {
                                            value: _vm.model.address,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.model,
                                                "address",
                                                $$v
                                              )
                                            },
                                            expression: "model.address"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "12", sm: "6" } },
                                      [
                                        _c("validation-provider", {
                                          attrs: { rules: "", name: "role" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("v-select", {
                                                      attrs: {
                                                        disabled: _vm.$auth.isInNeitherRole(
                                                          ["ADMIN", "TENANT"]
                                                        ),
                                                        items: _vm.roles,
                                                        label: _vm.$t(
                                                          "_users.user_role"
                                                        ),
                                                        outlined: "",
                                                        dense: "",
                                                        "error-messages": errors,
                                                        "hide-details": "auto"
                                                      },
                                                      model: {
                                                        value: _vm.model.role,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.model,
                                                            "role",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "model.role"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "12", sm: "6" } },
                                      [
                                        _vm.model.role !== "ADMIN"
                                          ? _c("tenant-select", {
                                              attrs: {
                                                outlined: "",
                                                dense: "",
                                                "hide-details": "auto"
                                              },
                                              model: {
                                                value: _vm.model.tenantId,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.model,
                                                    "tenantId",
                                                    $$v
                                                  )
                                                },
                                                expression: "model.tenantId"
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm.$auth.isInAnyRole(["ADMIN"])
                                  ? _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          [
                                            _c("password-input", {
                                              attrs: {
                                                outlined: "",
                                                dense: ""
                                              },
                                              model: {
                                                value: _vm.model.password,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.model,
                                                    "password",
                                                    $$v
                                                  )
                                                },
                                                expression: "model.password"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-card-actions",
                      { staticClass: "px-7 pb-5" },
                      [
                        _c("v-spacer"),
                        _c(
                          "v-btn",
                          {
                            staticClass: "primary--text",
                            attrs: { text: "" },
                            on: { click: _vm.cancel }
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                        ),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              disabled: !valid,
                              loading: _vm.loading,
                              depressed: "",
                              color: "primary"
                            },
                            on: { click: _vm.confirm }
                          },
                          [
                            _vm.editMode
                              ? _c("span", [_vm._v(_vm._s(_vm.$t("save")))])
                              : _c("span", [_vm._v(_vm._s(_vm.$t("add")))])
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }